export const memberCollectionCn = {
    xunjiadang:'会员收藏',
    fuwushoucang:'服务收藏',
    zhiliaoshoucang:'资料收藏',
    kechengshoucang:'课程收藏',
    zangjiashoucang:'专家收藏',
    quanxuan:'全选',
    quxiaoshoucang:'取消收藏',
    fuwuxinxi:'服务信息',
    shoucangshijian:'收藏时间',
    caozuo:'操作',
    jiage:'价格',
    kechengshijian:'课程信息',
    keshi:'课时',
    zuanjiajiesao:'专家介绍',
    zixunchishu:'咨询次数'
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/memberCollection/memberCollectionCn.js